import { Card
} from 'antd';

//style is for styling the Card element, styles is for styling the card components, header etc (see DataCards)
//header text is not wrapped by default (will be truncated if too long - default ant design), set to true to wrap the text
const DataCard = ({header, wrapHeader = false, style, children, extra, subHeader, styles, vertical, className, ...other}) => {

    return (
        <Card
            style={style}
            size= "small" 
            hoverable
            type="inner"
            className={'data-card ' + (wrapHeader ? 'data-card-wrap ' : 'data-card-nowrap ') + className}
            extra={extra}
            title={header
                   ? <div>
                        <div className='data-card-header'>{header}</div>
                        {subHeader
                         ? <div className='data-card-subheader'>{subHeader}</div>
                         : <></>}
                     </div>
                   : null
            }
            styles={styles}
            {...other}
        >
            <div className={vertical ? 'vertical data-card-content' : 'data-card-content'}>
                {children}
            </div>
        </Card>       
    );
}

export default DataCard;